import {z} from 'zod';

export const TireCategoryFormSchema = z.object({
  name: z.string(),
  branchIds: z.array(z.string()).nullish(),
});

export type TireCategoryForm = z.infer<typeof TireCategoryFormSchema>;
